import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Header,
  Modal,
} from 'semantic-ui-react';


export default class ModalNotice extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    headerNode: PropTypes.node,
    content: PropTypes.node,
    icon: PropTypes.string,
  }
  shouldComponentUpdate(nextProps) {
    if (this.props.open !== nextProps.open) {
      return true;
    }
    return false;
  }
  handleOnClose = (e) => {
    if (this.props.onClose) {
      this.props.onClose(e);
    }
  }
  render() {
    return (
      <Modal
        size="small"
        open={this.props.open === true}
        onClose={this.handleOnClose}
      >
        <Header icon={this.props.icon || undefined} content={this.props.headerNode || 'Notice'} />
        <Modal.Content>
          <Modal.Description>
            {this.props.content}
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.handleOnClose} content="Close" />
        </Modal.Actions>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/modals/ModalNotice.jsx